module.exports = __webpack_public_path__ + "img/ss-3.16a1edde.png";